// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SideBar_sidebar__UWUHS","submenu":"SideBar_submenu__2_ymh"};